import { render, staticRenderFns } from "./SvgImage.vue?vue&type=template&id=74dc5528&scoped=true&"
import script from "./SvgImage.vue?vue&type=script&lang=ts&"
export * from "./SvgImage.vue?vue&type=script&lang=ts&"
import style0 from "./SvgImage.vue?vue&type=style&index=0&id=74dc5528&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dc5528",
  null
  
)

export default component.exports